import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const location = useLocation();
    let token = localStorage.getItem('user_token') || {};

    try {
        token = JSON.parse(token);
    } catch (error) {
        token = {};
    }

    const authed =
        token.access_token &&
        token.expires_in &&
        token.expires_in > Date.now() / 1000;

    if (!authed) {
        localStorage.removeItem('user_token');
        const loginPath = location.pathname.startsWith('/concierge')
            ? '/concierge/login'
            : '/admin/login';
        return <Navigate to={loginPath} replace />;
    }

    return children;
};

export default PrivateRoute;
